import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const paymentMethod = {
  cash: "cash",
  card: "card",
  transfer: "transfer",
  store_wallet: "store_wallet",
  credit: "credit",
  split: "split",
  pr: "pr",
};

const schema = yup
  .object({
    paymentMethod: yup.mixed().oneOf(Object.values(paymentMethod)),
    customer_id: yup
      .string()
      .when(["paymentMethod", "splitCreditAmount", "requireCustomer"], {
        is: (val1, val2, val3) =>
          val1 === paymentMethod.credit ||
          val1 === paymentMethod.pr ||
          val3 === true ||
          (val1 === paymentMethod.split && val2?.length > 0),
        then: yup.string().required("Please choose a customer to continue"),
        otherwise: yup.string().notRequired(),
      }),
    wallet_id: yup.string().when(["paymentMethod", "splitStoreWalletAmount"], {
      is: (val1, val2) =>
        val1 === paymentMethod.store_wallet ||
        (val1 === paymentMethod.split && val2?.length > 0),
      then: yup.string().required("Please select customer wallet"),
      otherwise: yup.string().notRequired(),
    }),
    splitStoreWalletAmount: yup.string(),
    splitCreditAmount: yup.string(),
    hasExceedCreditLimt: yup
      .boolean()
      .when(["paymentMethod", "splitCreditAmount"], {
        is: (val1, val2) =>
          val1 === paymentMethod.credit ||
          (val1 === paymentMethod.split && val2?.length > 0),
        then: yup.boolean().oneOf([false], "Credit limit exceeded"),
      }),
    ledger_account_id: yup
      .string()
      .when(["paymentMethod", "requireLedgerAccount"], {
        is: (val1, val2) =>
          Boolean(val2) &&
          (val1 === paymentMethod.card ||
            val1 === paymentMethod.transfer ||
            val1 === paymentMethod.split),
        then: yup.string().required("Please select an account to continue"),
        otherwise: yup.string().notRequired(),
      }),
    requireLedgerAccount: yup.boolean().optional(),
    requireCustomer: yup.boolean().optional(),
  })
  .required();

export const useValidation = ({ ...details }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...details,
    },
  });
};
